import { reactive } from 'vue'

// 어디서든 로그인 모달을 띄우고 결과(성공/취소)를 기다릴 수 있게 하는 전역 상태.
export const authModalState = reactive({ open: false, resolve: null })

export function requireLogin() {
  return new Promise((resolve) => {
    authModalState.open = true
    authModalState.resolve = resolve
  })
}
